import React from "react";
import { useContext } from "react";
import { AuthContext } from "../context/AuthProvider";

function Dashboard() {
  const { user, logout } = useContext(AuthContext);
  return (
    <section id="dashboard">
      <h2>Dashboard</h2>
      <p>Estoy logado?</p>
      <button onClick={logout}>Cerrar sesión</button>
      <p>{user.email}</p>
    </section>
  );
}

export default Dashboard;